const resources = {
    pageTitle: 'Ouvrir une session pour profiter pleinement',
    personalizedBeautyTitle: 'Des conseils beauté adaptés à vos besoins',
    perksTitle: 'Offres et récompenses Beauty Insider',
    adviceTitle: 'Des conseils qui s’améliorent au fil du temps',
    emailPlaceholder: 'Courriel',
    passwordPlaceholder: 'Mot de passe',
    forgotPassword: 'Mot de passe oublié?',
    termsPrefix: 'En cliquant sur « Se connecter », vous (1) acceptez la version actuelle de nos ',
    termsOfUse: 'CONDITIONS D’UTILISATION',
    termsAnd: ' et (2) confirmez avoir lu notre ',
    privacyPolicy: 'politique de confidentialité',
    signInButton: 'Ouvrir une session',
    continueAsGuest: 'Continuer sans créer de compte',
    enterPasswordErrorMessage: 'Veuillez saisir votre mot de passe.',
    passwordLengthInvalid: 'Veuillez passer en revue votre mot de passe. Les mots de passe sont composés de 6 à 12 caractères.',
    emailEmpty: 'Veuillez saisir une adresse courriel au format nomutilisateur@domaine.com.',
    emailInvalid: 'Veuillez saisir une adresse courriel au format nomutilisateur@domaine.com.',
    unableToLogYouIn: 'Nous n’avons pas pu vous connecter. Veuillez réessayer.',
    genericErrorMessage: 'Échec de la connexion. Veuillez essayer de nouveau.',
    checkEmailPassword: 'Une erreur se produit avec votre adresse courriel ou votre mot de passe. Veuillez réessayer ou cliquer sur \« Mot de passe oublié »\.',
    verificationFailedTitle: 'Échec de la vérification',
    verificationFailedMessage: 'Nous n’avons pas été en mesure de vérifier votre session. Veuillez vous déconnecter et vous reconnecter pour continuer.',
    verificationFailedButton: 'OK',
    createAccount: 'Create Account',
    existingUserError: 'We’re sorry, there is an error with your email and/or password. Remember passwords are 6 to 12 characters (letters or numbers) long. Please try again or click Forgot Password.'
};

export default function getResource(label) {
    return resources[label];
}
